export default {
  FORMATTER_YMD: 'yyyy-MM-dd',

  format(time = new Date(), format = 'yyyy-MM-dd hh:mm:ss') {
    const o = {
      'M+': time.getMonth() + 1, // month
      'd+': time.getDate(), // day
      'h+': time.getHours(), // hour
      'm+': time.getMinutes(), // minute
      's+': time.getSeconds(), // second
      'q+': Math.floor((time.getMonth() + 3) / 3), // quarter
      S: time.getMilliseconds(), // millisecond
    };

    if (/(y+)/.test(format)) {
      format = format.replace(
        RegExp.$1,
        (time.getFullYear() + '').substr(4 - RegExp.$1.length)
      );
    }
    for (let k in o) {
      if (new RegExp(`(${k})`).test(format)) {
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
        );
      }
    }
    return format;
  },
  getJavaDateStr(date = new Date()) {
    // 月份英文
    const monthsEn = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const month = monthsEn[date.getMonth()];

    // 当前日期
    const day = date.getDate();

    // 当前年
    const year = date.getFullYear();

    // 格式化时间
    const hours =
      date.getHours() >= 12 ? date.getHours() - 12 : date.getHours();
    const time = this.format(date, 'mm:ss');

    // 上下午
    const format = date.getHours() >= 12 ? 'PM' : 'AM';

    return `${month} ${day}, ${year} ${hours}:${time} ${format}`;
  },
  dealIllegalData(dateStr) {
    // 排除无效日期字符串，转换为Date对象
    const isInvalid =
      dateStr === '0000-00-00 00:00:00' || dateStr === '0000-00-00';
    return isInvalid
      ? null // 无效日期设为null（避免显示错误）
      : dateStr instanceof Date
      ? dateStr
      : new Date(dateStr); // 字符串转Date
  },
};
